import React from 'react';
import Layout from '../../components/Layout/Layout';

const Partners = props => {
  return (
    <Layout showBackdrop={false} hideBanner={true}>
      <div>
        
      </div>
    </Layout>
  )
}

export default Partners;